import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faInfoCircle, faMobileAlt, faGavel, faRocket } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';

const Department = () => {
  const { t } = useLanguage();
  const [isActive, setIsActive] = useState(0);

  return (
    <section id="discover">
      <div className="st-height-b60 st-height-lg-b40" />
      <SectionHeading title={t('department.title')}
        subTitle={t('department.subtitle')} />
      <div className="container">
        <div className="st-tabs st-fade-tabs st-style1">
          <ul className="st-tab-links st-style1 st-mp0">
            <li className={`st-tab-title ${isActive === 0 ? "active" : ""}`} onClick={() => setIsActive(0)}>
              <span className="st-blue-box">
                <FontAwesomeIcon icon={faLightbulb} />
                <span>{t('department.tabs.origin')}</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 1 ? "active" : ""}`} onClick={() => setIsActive(1)}>
              <span className="st-red-box">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>{t('department.tabs.overview')}</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 2 ? "active" : ""}`} onClick={() => setIsActive(2)}>
              <span className="st-green-box">
                <FontAwesomeIcon icon={faMobileAlt} />
                <span>{t('department.tabs.digital')}</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 4 ? "active" : ""}`} onClick={() => setIsActive(4)}>
              <span className="st-orange-box">
                <FontAwesomeIcon icon={faGavel} />
                <span>{t('department.tabs.legal')}</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 5 ? "active" : ""}`} onClick={() => setIsActive(5)}>
              <span className="st-gray-box">
                <FontAwesomeIcon icon={faRocket} />
                <span>{t('department.tabs.future')}</span>
              </span>
            </li>
          </ul>
          <div className="st-height-b25 st-height-lg-b25" />
          <div className="tab-content">
            <div id="Origin" className={`st-tab ${isActive === 0 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="https://publichealth.tulane.edu/wp-content/uploads/sites/3/2024/04/healthcare-innovation.jpg" alt="origin" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.origin.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.origin.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.origin.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Overview" className={`st-tab ${isActive === 1 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/project-overview.jpg" alt="Project Overview" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.overview.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.overview.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.overview.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                          {/* <Link to="#"
                            className="st-btn st-style1 st-size-medium st-color1"
                          >
                            {t('department.content.overview.readMore')}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Digital" className={`st-tab ${isActive === 2 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/digital-function.jpg" alt="Digital Function" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.digital.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.digital.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.digital.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                          {/* <Link to="#"
                            className="st-btn st-style1 st-size-medium st-color1"
                          >
                            {t('department.content.digital.readMore')}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Community" className={`st-tab ${isActive === 3 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/community.jpg" alt="Community" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.community.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.community.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.community.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                          {/* <Link to="#"
                            className="st-btn st-style1 st-size-medium st-color1"
                          >
                            {t('department.content.community.readMore')}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Legal" className={`st-tab ${isActive === 4 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/legal-aspects.jpg" alt="Legal" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.legal.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.legal.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.legal.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                          {/* <Link to="#"
                            className="st-btn st-style1 st-size-medium st-color1"
                          >
                            {t('department.content.legal.readMore')}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Future" className={`st-tab ${isActive === 5 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/future-vision.jpg" alt="Future Vision" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            {t('department.content.future.title')}
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            {t('department.content.future.subtitle')}
                          </h4>
                          <div className="st-imagebox-text">
                            {t('department.content.future.text')}
                          </div>
                        </div>
                        <div className="st-imagebox-btn">
                          {/* <Link to="#"
                            className="st-btn st-style1 st-size-medium st-color1"
                          >
                            {t('department.content.future.readMore')}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="st-height-b60 st-height-lg-b40" />
    </section>
  );
};

export default Department;
